module.exports = __webpack_public_path__ + "img/input_sequence.b733c3a3.png";